'use strict';

const i18n = require('i18next');
const Mn = require('backbone.marionette');
require('backbone.stickit');
const MemberModel = require('common/domain/entity/project-member');
const GroupMemberSearchView = require('common/ui/view/group/member-search');
const ProjectRoleRepository = require('common/domain/repository/project-role');
const MemberItemEditView = require('balus/ui/view/body/project/modal/member-item-edit');
const Template = require('balus/ui/template/body/project/modal/member-edit.hbs');

const MemberListEditView = Mn.CollectionView.extend({
    childView: MemberItemEditView,
    childViewOptions: function() {
        return {
            context: this.getOption('context'),
            user: this.getOption('user'),
            projectRoles: this.getOption('projectRoles')
        }
    },
    childViewTriggers: {
        'change:member': 'change:member'
    },
    tagName: 'ul',
    className: 'list list-bordered',
    sort: false,

    onRender: function() {
        this.$('[data-toggle="tooltip"]').tooltip();
    },

    onChildviewDelete: function(child) {
        this.trigger('change:member');
        this.collection.remove(child.model);
    }
});

module.exports = Mn.View.extend({
    template: Template,
    regions: {
        memberList: '.member-list-wrapper',
        memberSearch: '.member-search'
    },

    childViewTriggers: {
        'change:member': 'change:member'
    },

    initialize: function() {
        this.collection = new Backbone.Collection(
            this.collection.map(m => m.clone()));
    },

    onRender: function() {
        ProjectRoleRepository.find(this.getOption('group')).fetchRoles()
            .then(projectRoles => {
                this.showChildView('memberList', new MemberListEditView({
                    collection: this.collection,
                    context: this.getOption('context'),
                    user: this.getOption('user'),
                    projectRoles: projectRoles
                }));
            });

        this.showChildView('memberSearch', new GroupMemberSearchView({
            group: this.getOption('group'),
            exclude: member => {
                return this.collection.find(pm => pm.getUser().id == member.getUser().id);
            }
        }));
        this.getChildView('memberSearch').on('select', groupMember => {
            this.add(groupMember);
            this.trigger('change:member');
        });
    },

    add: function(model) {
        const m = this.collection.filter(m => {
            return m.getUser().id == model.getUser().id;
        });
        if (m.length > 0) {
            const name = model.getUser().getName();
            this.$('.name .alert-message').html(
                i18n.t('input.member.selected.exists', {name: name}));
            return '';
        } else {
            this.$('.name .alert-message').html('');
            let memberModel = new MemberModel({
                user: model.getUser().toJSON(),
                role: 'owner'
            });

            this.collection.add(memberModel);
            return '';
        }
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/project/modal/member-edit.js